import { httpClient } from '@/services/http/httpClient'

export type UpdateTagProps = {
  id: string
  name?: string
  textColor?: string
  color?: string
  projectId: string
}

export const updateTag = async ({
  id,
  name,
  textColor,
  color,
  projectId,
}: UpdateTagProps) => {
  const { data } = await httpClient.put(
    `/projects/portfolio-tags/${projectId}/${id}`,
    { name, textColor, color, projectId },
  )
  return data
}
